import "./App.css";
import React from "react";
import Registration from "./registration-ui";

function App() {
  const empGuid = document.getElementById("employeeGuid")?.value;

  return (
    <div className="App" id="app-container">
      <Registration GUID={empGuid} id="registration-component" />
    </div>
  );
}

export default App;
